<div
    [routerLink]="item().link"
    [routerLinkActive]="['router-link-active']" [routerLinkActiveOptions]="{exact: true}"
    class="px-3 py-1.5 hover:bg-[#F7F7F866] rounded-full cursor-pointer 2xl:text-[0.8rem] text-xs my-0.5" [ngClass]="minimized() ? 'my-1 text-center' : 'my-0.5'"
    (click)="onActive()"
  >

    <i  [routerLinkActive]="['router-link-active']" [routerLinkActiveOptions]="{exact: true}" [className]="item().icon" [ngClass]="minimized() ? 'text-base me-0' : 'text-sm me-1'"></i>
    {{ minimized() ? '' : (item().title | translate) }}
</div>
